import React from 'react';

import { RouteComponentProps, Redirect } from 'react-router-dom';
import { getUser } from '../../lib/api/user';
import { User } from '../../../shared/types/user';

import { getUserToken } from '../../lib/auth';
import { Anchor } from '@spark-labs/avocado-ui';

export type HomePageProps = RouteComponentProps;

export interface HomePageState {
  user?: User;
}

/**
 * Dummy component that retrieves the user data and redirects to the appropriate page (currently
 * the user's property)
 *
 */
export default class Home extends React.Component<HomePageProps, HomePageState> {
  public readonly state: HomePageState = {};

  public async componentWillMount() {
    let user = await getUser();
    this.setState({ user });
  }

  public render() {
    let userToken = getUserToken();

    // ensure there's a valid user token, otherwise redirect to login page
    if (!userToken) return <Redirect to="/crew/login" />;

    // If there's a user token but there isn't a user in the state, it means we are still loading
    // it. Just keep waiting
    if (!this.state.user) {
      return <div>Retrieving user info</div>;
    }

    if (!this.state.user.staffRole) {
      return (
        <div>
          <div>This user has no staff assignment</div>
          <Anchor href="/crew/login">Back to login</Anchor>
        </div>
      );
    }

    return <Redirect to={`/crew/schedule/${this.state.user.staffRole}`} />;
  }
}
